import { render, staticRenderFns } from "./ThePaymentMethodChoice.vue?vue&type=template&id=8721949a"
import script from "./ThePaymentMethodChoice.vue?vue&type=script&lang=js"
export * from "./ThePaymentMethodChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports